import { z } from "zod";

export const restoreArchivedSolutionsResponseSchema = z.object({
	updates: z.number(),
	replaces: z.number(),
});

export const tenantArchivedSolutionStatsSchema = z.object({
	totalCount: z.number(),
	conflictCount: z.number(),
	expiringTimeFrame: z.string().nullable().optional(),
});

export const downloadImportClientResponseSchema = z.object({
	downloadUri: z.string(),
});

export type RestoreArchivedSolutionsResponse = z.infer<typeof restoreArchivedSolutionsResponseSchema>;
export type TenantArchivedSolutionStats = z.infer<typeof tenantArchivedSolutionStatsSchema>;
export type DownloadImportClientResponse = z.infer<typeof downloadImportClientResponseSchema>;
